/** Explicit page allowlist from midterm_margin_pairs_to_merge_2026-09-04.csv, plus KSSEN, AKGOV, MIGOV and MNSEN (listed later). */
export interface SyntheticMarginEventDefinition {
    ticker: string;
    title: string;
    sourceEventTickers: readonly [string, string];
}

/** The only series whose events may be presented as a combined margin page. */
export const SYNTHETIC_MARGIN_SERIES_TICKER = 'KXMIDTERMMOV';

const races = [
    ['KXMIDTERMMOV-AKSEN', 'Alaska Senate margin of victory'],
    ['KXMIDTERMMOV-FLSEN', 'Florida Senate margin of victory'],
    ['KXMIDTERMMOV-GASEN', 'Georgia Senate margin of victory'],
    ['KXMIDTERMMOV-IASEN', 'Iowa Senate margin of victory'],
    ['KXMIDTERMMOV-KSSEN', 'Kansas Senate margin of victory'],
    ['KXMIDTERMMOV-MESEN', 'Maine Senate margin of victory'],
    ['KXMIDTERMMOV-MISEN', 'Michigan Senate margin of victory'],
    ['KXMIDTERMMOV-MNSEN', 'Minnesota Senate margin of victory'],
    ['KXMIDTERMMOV-NHSEN', 'New Hampshire Senate margin of victory'],
    ['KXMIDTERMMOV-NCSEN', 'North Carolina Senate margin of victory'],
    ['KXMIDTERMMOV-OHSEN', 'Ohio Senate margin of victory'],
    ['KXMIDTERMMOV-SCSEN', 'South Carolina Senate margin of victory'],
    ['KXMIDTERMMOV-TXSEN', 'Texas Senate margin of victory'],
    ['KXMIDTERMMOV-AKGOV', 'Alaska Governor margin of victory'],
    ['KXMIDTERMMOV-AZGOV', 'Arizona Governor margin of victory'],
    ['KXMIDTERMMOV-FLGOV', 'Florida Governor margin of victory'],
    ['KXMIDTERMMOV-GAGOV', 'Georgia Governor margin of victory'],
    ['KXMIDTERMMOV-IAGOV', 'Iowa Governor margin of victory'],
    ['KXMIDTERMMOV-KSGOV', 'Kansas Governor margin of victory'],
    ['KXMIDTERMMOV-MEGOV', 'Maine Governor margin of victory'],
    ['KXMIDTERMMOV-MIGOV', 'Michigan Governor margin of victory'],
    ['KXMIDTERMMOV-NVGOV', 'Nevada Governor margin of victory'],
    ['KXMIDTERMMOV-NHGOV', 'New Hampshire Governor margin of victory'],
    ['KXMIDTERMMOV-OHGOV', 'Ohio Governor margin of victory'],
    ['KXMIDTERMMOV-SCGOV', 'South Carolina Governor margin of victory'],
    ['KXMIDTERMMOV-TXGOV', 'Texas Governor margin of victory'],
    ['KXMIDTERMMOV-WIGOV', 'Wisconsin Governor margin of victory'],
    ['KXMIDTERMMOV-AZ01', "Arizona's 1st District margin of victory"],
    ['KXMIDTERMMOV-AZ02', "Arizona's 2nd District margin of victory"],
    ['KXMIDTERMMOV-AZ06', "Arizona's 6th District margin of victory"],
    ['KXMIDTERMMOV-CA22', "California's 22nd District margin of victory"],
    ['KXMIDTERMMOV-CA48', "California's 48th District margin of victory"],
    ['KXMIDTERMMOV-CO03', "Colorado's 3rd District margin of victory"],
    ['KXMIDTERMMOV-CO04', "Colorado's 4th District margin of victory"],
    ['KXMIDTERMMOV-CO05', "Colorado's 5th District margin of victory"],
    ['KXMIDTERMMOV-CO08', "Colorado's 8th District margin of victory"],
    ['KXMIDTERMMOV-FL04', "Florida's 4th District margin of victory"],
    ['KXMIDTERMMOV-FL07', "Florida's 7th District margin of victory"],
    ['KXMIDTERMMOV-FL13', "Florida's 13th District margin of victory"],
    ['KXMIDTERMMOV-FL15', "Florida's 15th District margin of victory"],
    ['KXMIDTERMMOV-FL16', "Florida's 16th District margin of victory"],
    ['KXMIDTERMMOV-FL23', "Florida's 23rd District margin of victory"],
    ['KXMIDTERMMOV-FL27', "Florida's 27th District margin of victory"],
    ['KXMIDTERMMOV-IA01', "Iowa's 1st District margin of victory"],
    ['KXMIDTERMMOV-IA02', "Iowa's 2nd District margin of victory"],
    ['KXMIDTERMMOV-IA03', "Iowa's 3rd District margin of victory"],
    ['KXMIDTERMMOV-KY06', "Kentucky's 6th District margin of victory"],
    ['KXMIDTERMMOV-ME02', "Maine's 2nd District margin of victory"],
    ['KXMIDTERMMOV-MI04', "Michigan's 4th District margin of victory"],
    ['KXMIDTERMMOV-MI07', "Michigan's 7th District margin of victory"],
    ['KXMIDTERMMOV-MI08', "Michigan's 8th District margin of victory"],
    ['KXMIDTERMMOV-MI10', "Michigan's 10th District margin of victory"],
    ['KXMIDTERMMOV-MN01', "Minnesota's 1st District margin of victory"],
    ['KXMIDTERMMOV-MN08', "Minnesota's 8th District margin of victory"],
    ['KXMIDTERMMOV-MO02', "Missouri's 2nd District margin of victory"],
    ['KXMIDTERMMOV-MO05', "Missouri's 5th District margin of victory"],
    ['KXMIDTERMMOV-MT01', "Montana's 1st District margin of victory"],
    ['KXMIDTERMMOV-NC01', "North Carolina's 1st District margin of victory"],
    ['KXMIDTERMMOV-NC11', "North Carolina's 11th District margin of victory"],
    ['KXMIDTERMMOV-NE02', "Nebraska's 2nd District margin of victory"],
    ['KXMIDTERMMOV-NH01', "New Hampshire's 1st District margin of victory"],
    ['KXMIDTERMMOV-NJ02', "New Jersey's 2nd District margin of victory"],
    ['KXMIDTERMMOV-NJ07', "New Jersey's 7th District margin of victory"],
    ['KXMIDTERMMOV-NV02', "Nevada's 2nd District margin of victory"],
    ['KXMIDTERMMOV-NV03', "Nevada's 3rd District margin of victory"],
    ['KXMIDTERMMOV-NY01', "New York's 1st District margin of victory"],
    ['KXMIDTERMMOV-NY02', "New York's 2nd District margin of victory"],
    ['KXMIDTERMMOV-NY03', "New York's 3rd District margin of victory"],
    ['KXMIDTERMMOV-NY17', "New York's 17th District margin of victory"],
    ['KXMIDTERMMOV-NY19', "New York's 19th District margin of victory"],
    ['KXMIDTERMMOV-OH01', "Ohio's 1st District margin of victory"],
    ['KXMIDTERMMOV-OH07', "Ohio's 7th District margin of victory"],
    ['KXMIDTERMMOV-OH09', "Ohio's 9th District margin of victory"],
    ['KXMIDTERMMOV-OH10', "Ohio's 10th District margin of victory"],
    ['KXMIDTERMMOV-OH15', "Ohio's 15th District margin of victory"],
    ['KXMIDTERMMOV-PA01', "Pennsylvania's 1st District margin of victory"],
    ['KXMIDTERMMOV-PA07', "Pennsylvania's 7th District margin of victory"],
    ['KXMIDTERMMOV-PA08', "Pennsylvania's 8th District margin of victory"],
    ['KXMIDTERMMOV-PA10', "Pennsylvania's 10th District margin of victory"],
    ['KXMIDTERMMOV-SC01', "South Carolina's 1st District margin of victory"],
    ['KXMIDTERMMOV-TN05', "Tennessee's 5th District margin of victory"],
    ['KXMIDTERMMOV-TX09', "Texas's 9th District margin of victory"],
    ['KXMIDTERMMOV-TX15', "Texas's 15th District margin of victory"],
    ['KXMIDTERMMOV-TX23', "Texas's 23rd District margin of victory"],
    ['KXMIDTERMMOV-TX28', "Texas's 28th District margin of victory"],
    ['KXMIDTERMMOV-TX32', "Texas's 32nd District margin of victory"],
    ['KXMIDTERMMOV-TX34', "Texas's 34th District margin of victory"],
    ['KXMIDTERMMOV-TX35', "Texas's 35th District margin of victory"],
    ['KXMIDTERMMOV-VA01', "Virginia's 1st District margin of victory"],
    ['KXMIDTERMMOV-VA02', "Virginia's 2nd District margin of victory"],
    ['KXMIDTERMMOV-VA05', "Virginia's 5th District margin of victory"],
    ['KXMIDTERMMOV-VA06', "Virginia's 6th District margin of victory"],
    ['KXMIDTERMMOV-WA03', "Washington's 3rd District margin of victory"],
    ['KXMIDTERMMOV-WA05', "Washington's 5th District margin of victory"],
    ['KXMIDTERMMOV-WI01', "Wisconsin's 1st District margin of victory"],
    ['KXMIDTERMMOV-WI03', "Wisconsin's 3rd District margin of victory"],
] as const;

export const syntheticMarginEvents: readonly SyntheticMarginEventDefinition[] = races.map(([ticker, title]) => ({
    ticker,
    title,
    sourceEventTickers: [`${ticker}D`, `${ticker}R`],
}));

const definitions = new Map(syntheticMarginEvents.map((event) => [event.ticker, event]));
const aliases = new Map(
    syntheticMarginEvents.flatMap((event) => event.sourceEventTickers.map((ticker) => [ticker, event] as const)),
);

/** Resolves a page or source event. Never infers pairs outside the allowlist. */
export const getSyntheticMarginEvent = (ticker: string | null | undefined) =>
    definitions.get(ticker?.toUpperCase() ?? '') ?? aliases.get(ticker?.toUpperCase() ?? '');

/** True only for a presentation ticker, not a real exchange event. */
export const getSyntheticMarginPage = (ticker: string | null | undefined) =>
    definitions.get(ticker?.toUpperCase() ?? '');

export const resolveEventPageTicker = (ticker: string): string => getSyntheticMarginEvent(ticker)?.ticker ?? ticker;

/** The real exchange events that back a page ticker: both sources for a margin page, else the ticker itself. */
export const eventPageSourceTickers = (ticker: string): string[] => [
    ...(getSyntheticMarginPage(ticker)?.sourceEventTickers ?? [ticker]),
];
